<template>
  <nav class="top-nav">
    <a-icon type="left" class="top-nav__return" @click="back" />
    <span class="top-nav__title">{{ title }}</span>
    <router-link :to="{ path: '/' }"><a-icon type="home" class="top-nav__home" /></router-link>
  </nav>
</template>

<script>

export default {
  name: "TopNav",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
  },
  mounted() {},
  computed: {},
  methods: {
      back() {
          this.$router.go(-1);
      }
  },
};
</script>

<style lang="scss" scoped>
.top-nav {
  position: relative;
  background-color: #e67e22;
  height: 44px;
  line-height: 44px;
  padding: 0 4rem;
  text-align: center;
  font-size: 16px;
  .top-nav__return {
    position: absolute;
    top: 13px;
    left: 0;
    width: 2.2rem;
    height: 2.2rem;
    color: #fff;
  }
  .top-nav__title {
    display: inline-block;
    max-width: 100%;
    color: #fff;
    font-weight: 400;
  }
  .top-nav__home {
    width: 2.2rem;
    height: 2.2rem;
    position: absolute;
    top: 13px;
    right: 0;
    color: #fff;
  }
}
</style>
